export default {
    STORE_PATH: "primgidrometApp",

    // STATE
    APP_INITIALIZED: "APP_INITIALIZED",

    // ACTIONS
    INIT_APP: "INIT_APP",
};